import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

const SkipLinkContainer = styled.a`
  position: absolute;
  top: -100px;
  left: 0;
  z-index: 1000;
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  text-decoration: none;
  font-weight: ${theme.fontWeight.semibold};
  font-family: 'Inter', sans-serif;
  border-radius: 0 0 ${theme.borderRadius.md} 0;
  transition: top 0.2s ease;

  &:focus {
    top: 0;
    outline: 3px solid ${theme.colors.accent};
    outline-offset: 2px;
  }
`;

interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
}

export const SkipLink: React.FC<SkipLinkProps> = ({ href, children }) => {
  return (
    <SkipLinkContainer href={href}>
      {children}
    </SkipLinkContainer>
  );
};

